import { HttpService } from "../../modules/shared/services/http.service";
import {
  LocationSeo,
  LocationSeoCreateDto,
  LocationSeoUpdateDto,
  LocationSeoResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Location SEO CRUD Functions
export const createLocationSeo = async (data: LocationSeoCreateDto): Promise<LocationSeo> => {
  const response = await HttpService.post("api/v1/location-seos", data, headers, true);
  return response;
};

export const updateLocationSeo = async (id: string, data: LocationSeoUpdateDto): Promise<LocationSeo> => {
  const response = await HttpService.patch(`api/v1/location-seos/${id}`, data, headers, true);
  return response;
};

export const getLocationSeoById = async (id: string): Promise<LocationSeo> => {
  const response = await HttpService.get(`api/v1/location-seos/${id}`, true, { "x-custom-lang": "en" });
  return response;
};

export const getLocationSeos = async (query?: Record<string, string | number | boolean>): Promise<LocationSeoResponse> => {
  const qs = new URLSearchParams();
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) qs.append(k, String(v));
  });
  const response = await HttpService.get(`api/v1/location-seos${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
  return response;
};

export const deleteLocationSeo = async (id: string): Promise<void> => {
  await HttpService.deleteRecord(`api/v1/location-seos/${id}`, { "x-custom-lang": "en" }, true);
};

// Get Location SEOs by Country
export const getLocationSeosByCountry = async (countryId: string): Promise<LocationSeo[]> => {
  const response = await HttpService.get(`api/v1/location-seos/country/${countryId}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get Location SEOs by Region
export const getLocationSeosByRegion = async (regionId: string): Promise<LocationSeo[]> => {
  const response = await HttpService.get(`api/v1/location-seos/region/${regionId}`, true, { "x-custom-lang": "en" });
  return response;
};

// Get Location SEOs by City
export const getLocationSeosByCity = async (cityId: string): Promise<LocationSeo[]> => {
  const response = await HttpService.get(`api/v1/location-seos/city/${cityId}`, true, { "x-custom-lang": "en" });
  return response;
};
